import { Box, BoxProps, Button, IconArrowLeft } from '@cmpsr/components';

interface SubNavBarProps extends BoxProps {
  onClick?: () => void;
  children: React.ReactNode;
}

export default function SubNavBar({ onClick, children, ...props }: SubNavBarProps) {
  return (
    <Box
      as="nav"
      mb="0"
      pt={{ base: 4, md: 4, lg: 6 }}
      pb={{ base: 5, md: 6, lg: 8 }}
      w="100%"
      maxWidth="1440px"
      marginX="auto"
      textAlign="left"
      {...props}
    >
      <Button
        variant="link-primary"
        onClick={onClick}
        width="min-content"
        leadingIcon={<IconArrowLeft boxSize={5} />}
        fontSize={{ base: '14px', lg: '16px' }}
        textTransform="uppercase"
      >
        {children}
      </Button>
    </Box>
  );
}
